import { useState } from "react";
import { motion } from "framer-motion";

function ContactForm() {
  const [formData, setFormData] = useState({
    name: "",
    telephone: "",
    email: "",
    prestation: "default",
    description: "",
    rgpd: false,
  });

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData({
      ...formData,
      [name]: type === "checkbox" ? checked : value,
    });
  };

  const generateMailto = () => {
    const subject = encodeURIComponent("Demande de devis - Photographie");
    const body = encodeURIComponent(
      `Bonjour,

Je souhaite obtenir un devis pour une prestation de photographie.

Voici mes informations :
- Nom : ${formData.name}
- Téléphone : ${formData.telephone}
- Email : ${formData.email}
- Prestation : ${
        formData.prestation !== "default" ? formData.prestation : "Non précisée"
      }

Description du projet :
${formData.description}

Merci d'avance pour votre retour !
Cordialement.`
    );

    return `mailto:tonemail@example.com?subject=${subject}&body=${body}`;
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    // Validation simple avant envoi
    if (
      !formData.name.trim() ||
      !formData.telephone.trim() ||
      !formData.email.trim() ||
      formData.prestation === "default" ||
      !formData.description.trim() ||
      !formData.rgpd
    ) {
      alert(
        "Veuillez remplir tous les champs obligatoires et accepter la politique de confidentialité."
      );
      return;
    }

    // Si tout est ok, on ouvre le mailto
    window.location.href = generateMailto();

    // Reset du formulaire
    setTimeout(() => {
      setFormData({
        name: "",
        telephone: "",
        email: "",
        prestation: "default",
        description: "",
        rgpd: false,
      });
    }, 100);
  };

  return (
    <form className="formContact" onSubmit={handleSubmit}>
      <motion.div
        className="nameContact"
        initial={{ opacity: 0, x: -50 }}
        animate={{ opacity: 1, x: 0 }}
        transition={{ delay: 0.1, duration: 0.5 }}
      >
        <label htmlFor="nameContact">Nom</label>
        <input
          maxLength={50}
          placeholder="Ripley"
          required
          name="name"
          type="text"
          id="nameContact"
          value={formData.name}
          onChange={handleChange}
        />
      </motion.div>

      <motion.div
        className="telContact"
        initial={{ opacity: 0, x: -50 }}
        animate={{ opacity: 1, x: 0 }}
        transition={{ delay: 0.2, duration: 0.5 }}
      >
        <label htmlFor="telContact">Téléphone</label>
        <input
          required
          maxLength={20}
          placeholder="+33 6 62 54 85 85"
          type="tel"
          id="telContact"
          name="telephone"
          value={formData.telephone}
          onChange={handleChange}
        />
      </motion.div>

      <motion.div
        className="emailContact"
        initial={{ opacity: 0, x: -50 }}
        animate={{ opacity: 1, x: 0 }}
        transition={{ delay: 0.3, duration: 0.5 }}
      >
        <label htmlFor="emailContact">Email</label>
        <input
          required
          maxLength={50}
          placeholder="ellen.ripley@example.com"
          type="email"
          id="emailContact"
          name="email"
          value={formData.email}
          onChange={handleChange}
        />
      </motion.div>

      <motion.div
        className="prestations"
        initial={{ opacity: 0, x: -50 }}
        animate={{ opacity: 1, x: 0 }}
        transition={{ delay: 0.4, duration: 0.5 }}
      >
        <label htmlFor="prestation">Prestations :</label>
        <select
          required
          id="prestation"
          name="prestation"
          value={formData.prestation}
          onChange={handleChange}
        >
          <option value="default" disabled>
            Sélectionnez une prestation
          </option>
          <option value="shooting">Shooting</option>
          <option value="portrait">Portrait</option>
          <option value="evenements">Événements</option>
          <option value="mariage">Mariage</option>
        </select>
      </motion.div>

      <motion.div
        className="description"
        initial={{ opacity: 0, x: -50 }}
        animate={{ opacity: 1, x: 0 }}
        transition={{ delay: 0.5, duration: 0.5 }}
      >
        <label htmlFor="description">Description :</label>
        <textarea
          required
          id="description"
          name="description"
          maxLength={3000}
          placeholder="Faites une pause créative et partagez les angles de votre projet pour que je puisse cadrer un devis parfait"
          rows="4"
          value={formData.description}
          onChange={handleChange}
        />
      </motion.div>

      <motion.div
        className="rgpd-checkbox"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ delay: 0.6, duration: 0.5 }}
      >
        <input
          type="checkbox"
          id="rgpd"
          name="rgpd"
          checked={formData.rgpd}
          onChange={handleChange}
          required
        />
        <label htmlFor="rgpd" className="rgpd-label">
          J’accepte la{" "}
          <a href="/rgpd" target="_blank" rel="noopener noreferrer">
            politique de confidentialité
          </a>
        </label>
      </motion.div>

      <motion.button
        type="submit"
        className="contact-button"
        whileHover={{ scale: 1.1 }}
        whileTap={{ scale: 0.9 }}
      >
        Envoyer par email
      </motion.button>
    </form>
  );
}

export default ContactForm;
